import React from 'react';
import _ from 'lodash';
import { Link } from 'gatsby';

export default function Button(props) {
  const buttonType = props.href;

  return (
    <>
      {(!_.includes(buttonType, 'mailto') || !props.pdf) &&
      !_.includes(buttonType, 'https') ? (
        <Link
          to={props.href}
          className={`inline-flex p-6 rounded-md duration-300 justify-center 
                    ${
                      props.red
                        ? 'border border-red-500 text-red-500 hover:bg-red-500 hover:text-white'
                        : 'border-2 border-gray-700 bg-gray-700 text-white hover:bg-red-500'
                    } 
                    ${
                      props.redfilled
                        ? 'bg-red-500 border-red-500 hover:border-gray-700'
                        : ''
                    } 
                    ${
                      props.ghost
                        ? `bg-none text-gray-700 hover:text-white`
                        : ''
                    }`}
        >
          {props.link}
        </Link>
      ) : (
        <a
          href={buttonType}
          target={props.newTab ? '_blank' : '_self'}
          rel="noreferrer"
          className={`${
            props.customClass
          } inline-flex p-6 rounded-md duration-300 justify-center 
                ${
                  props.red
                    ? 'border border-red-500 text-red-500 hover:bg-red-500 hover:text-white'
                    : 'border-2 border-gray-700 bg-gray-700 text-white hover:bg-green-500'
                } 
                ${
                  props.redfilled
                    ? 'bg-red-500 border-red-500 hover:border-gray-700'
                    : ''
                } 
                ${props.ghost ? `bg-none text-gray-700 hover:text-white` : ''}`}
        >
          {props.link}
        </a>
      )}
    </>
  );
}
